import OrderAddressText from './OrderAddressText';
import styled from 'styled-components';

export default function LinkedProductName({ name }: { name: string }) {
  return <Product>
    <div className="linked-product-title"><svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 3v7a3 3 0 0 0 3 3h9m-4-4 4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg><OrderAddressText address={name} /></div>
  </Product>;
}
const Product = styled.div`
  display: grid; gap: var(--space-1); width: 100%; min-width: 0; text-align: left; overflow-wrap: anywhere;
  .linked-product-title { display: flex; align-items: baseline; gap: var(--space-2); font-weight: var(--font-weight-medium); }
  svg { width: 1em; height: 1em; flex-shrink: 0; color: var(--color-text-secondary); }
`;
